import type { CSSProperties } from 'react';

/** Width of the invisible stroke that makes thin edges easy to click (v11 default). */
export const DEFAULT_INTERACTION_WIDTH = 20;

export type BaseEdgeProps = {
  id: string;
  path: string;
  style?: CSSProperties;
  interactionWidth?: number;
  /** `url(#id)` of an SVG marker drawn at the start / end of the path. */
  markerStart?: string;
  markerEnd?: string;
};

/** The visible path plus a wide transparent path that receives clicks. */
export const BaseEdge = ({ id, path, style, interactionWidth = DEFAULT_INTERACTION_WIDTH, markerStart, markerEnd }: BaseEdgeProps) => (
  <>
    <path id={id} d={path} fill="none" className="cm-edge-path" style={style} markerStart={markerStart} markerEnd={markerEnd} />
    {interactionWidth > 0 && (
      <path d={path} fill="none" strokeOpacity={0} strokeWidth={interactionWidth} className="cm-edge-interaction" />
    )}
  </>
);
